<template>
  <v-dialog v-model="isOpen" max-width="600px" persistent>
    <v-card class="invites-sent-modal" rounded="lg">
      <v-card-text class="modal-content">
        <h1 class="modal-title">Invites sent!</h1>
        <p class="modal-message">
          We sent invites to <strong>{{ sentCount }}</strong> {{ sentCount === 1 ? 'person' : 'people' }}.
          We will notify you when they accept.
        </p>

        <div class="action-buttons">
          <v-btn
            rounded
            class="close-btn"
            min-width="160"
            height="40"
            @click="close"
          >
            Close
          </v-btn>

          <v-btn
            rounded
            class="invite-more-btn"
            min-width="200"
            height="40"
            @click="inviteMore"
          >
            <v-icon left size="18">fa-regular fa-user-plus</v-icon>
            Invite more members
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'InvitesSentModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    sentCount: {
      type: Number,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },

    inviteMore() {
      this.$emit('invite-more')
    }
  }
}
</script>

<style scoped lang="scss">
.invites-sent-modal {
  padding: 32px 24px;
}

.modal-content {
  text-align: center;
  padding: 24px !important;
}

.modal-title {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  color: #14161B;
  margin-bottom: 24px;
}

.modal-message {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #6B6B6B;
  margin-bottom: 40px;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  strong {
    color: #14161B;
    font-weight: 600;
  }
}

.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.broker-app .v-application .v-btn.close-btn,
#broker-app .v-application .v-btn.close-btn {
  background-color: #EBEBEB !important;
  color: #14161B !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    background-color: #D9D9D9 !important;
  }

  &:not(.v-btn--disabled) {
    background-color: #EBEBEB !important;
    color: #14161B !important;
  }
}

.invite-more-btn {
  background-color: #28EA96 !important;
  color: #005931 !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    background-color: #1FD67F !important;
  }
}

@media (max-width: 600px) {
  .modal-title {
    font-size: 2.25rem;
  }

  .modal-message {
    font-size: 1rem;
  }

  .action-buttons {
    flex-direction: column;

    .close-btn,
    .invite-more-btn {
      width: 100%;
    }
  }
}
</style>
